import type { ReactNode } from 'react';

import { EmptyState, ErrorState, LoadingState } from '@/components/stateViews';
import type { StateTone } from '@/components/stateViews';

type DataPanelProperties = {
  children: ReactNode;
  empty?: boolean;
  emptyChildren?: ReactNode;
  emptyTitle?: string;
  emptyTone?: StateTone;
  error?: Error | null;
  isError?: boolean;
  isLoading?: boolean;
  loadingLabel?: string;
  onRetry?: () => void;
};

export const DataPanel = ({
  children,
  empty = false,
  emptyChildren,
  emptyTitle = 'No data found',
  emptyTone = 'neutral',
  error,
  isError = false,
  isLoading = false,
  loadingLabel,
  onRetry,
}: DataPanelProperties) => {
  if (isLoading) {
    return <LoadingState label={loadingLabel} />;
  }

  if (isError || error) {
    return <ErrorState message={error?.message ?? 'Failed to load data'} onRetry={onRetry} />;
  }

  if (empty) {
    return (
      <EmptyState title={emptyTitle} tone={emptyTone}>
        {emptyChildren}
      </EmptyState>
    );
  }

  return <>{children}</>;
};
